import { useEffect} from 'react';
import { useApi } from "./api"
import { LoginDTO, RegisterDTO, UploadDocumentDTO, CheckAccountDTO } from "../models"
import { useContextState } from '../context/Context';
import Cookies from 'js-cookie';



export const useAccountApi = () => {
    const { accountCTX } = useContextState();
    const { signedIn, setSignedIn, profile, setProfile } = accountCTX
    const { $post, $get } = useApi()

    const getUserDetails = async (credentials: {userId: string}) => {
        var path = 'account/get_user_details/'
        const data = await $post(path, credentials, true)
        // if (data.res !== 'success'){return }
        return data
    }

    const getAccountTransactions = async (id?:string) => {
        var path = 'transactions/'
        if (id){path = path + id + '/'}
        const data = await $get(path, true)
        // if (data.res !== 'success'){return }
        return data
    }

    const getPlatformStats = async () => {
        const data = await $get('account/get_platform_stats/', true)
        if (data && data.res === 'success') { return data }
        return
    }

    const getUserTransactions = async (userId?: string) => {
        const data = await $post('account/get_user_transactions/', { userId: userId ?? '' }, true)
        if (data && (data.res === 'success' || data.res === 'failed')) { return data }
        return
    }

    const updateUserStatus = async (credentials: { userId: string; status: 'active' | 'suspended' }) => {
        const data = await $post('account/update_user_status/', credentials, true)
        if (data && (data.res === 'success' || data.res === 'failed')) { return data }
        return
    }

    const getMyCalendar = async (credentials: {year?: string, month?:string}) => {
        const data = await $post('my_calendar/', credentials, true)
        // console.log(data)
        if (data && (data.res === 'success' || data.res === 'failed')){
            return data
        }
        return 
    }

    


    return { getUserDetails, getAccountTransactions, getMyCalendar, getPlatformStats, getUserTransactions, updateUserStatus }
}
